
    /**
    * 前台用户获取验证码
    **/
      
  import request, {AxiosPromise} from '@utils/request'
  export class IReqid13235 {
  /**
   * 手机号
   */
  mobile: string | number;
}
  export class IResid13235 {
  code?: number;
  data?: string;
  message?: string;
  success?: boolean;
}
  type Serve<T, G> = (data?: T) => AxiosPromise<G>
  const http: Serve<IReqid13235, IResid13235['data'] > = (data?) =>  request({
        method: 'GET',
        url: '/account/sms',
        params: data
      }) 
  export default http